import React, { useState } from 'react'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import LoadingComponent from './Loading';
import classnames from "classnames";
import PropTypes from "prop-types";


export default function Paginacion(props){
    const {traerObjetos, setObjetos, getObjetos, ZonaEsp} = props
    const [Paginado, setPaginado] = useState(1);
    const [Visible, setVisible] = useState(false);
    const [estado, setState] = useState(null);

    const toggleNavs = (e, state, index) => {
      e.preventDefault();
     setState(index);
    };

    const paginar = async(accion)=>{
      setVisible(true)

      let nuevaPagina = Paginado;
      if (accion === "ATRAS") {
        if (Paginado > 1) nuevaPagina = Paginado - 1;
      } else if (accion === "ADELANTE") {
        nuevaPagina = Paginado + 1;
      } else {
        nuevaPagina = parseInt(accion);
      }
      setPaginado(nuevaPagina);

      let params = null;
      if (nuevaPagina > 1) {
        if(ZonaEsp){
          params = {page: nuevaPagina, estado:1, zonaId:ZonaEsp}
        }else{
          params = {page: nuevaPagina, estado:1}
        }
      } else {
        if(ZonaEsp){
          params = {paginate:"si", page: nuevaPagina, estado:1, zonaId:ZonaEsp}
        }else{
          params = {paginate:"si", page: nuevaPagina, estado:1}
        }
      }

      let result = await getObjetos(params)
      if(result != null){
          setObjetos(result);
      }else{alert("no se pudo cambiar de pagina"); traerObjetos(1)}
      setVisible(false)
    }
    

    return(
      <>
      <LoadingComponent Visible={Visible}/>
      
        <nav aria-label="Page navigation example">
            <Pagination
            className="pagination justify-content-center flex-column flex-sm-row"
            id="tabs-text"
            role="tablist"
            >
            <PaginationItem>
                <PaginationLink
                
                onClick={() => paginar("ATRAS")}
                tabIndex="-1"
                role="tab"
                >
                <i className="fa fa-angle-left" />
                <span className="sr-only">Atras</span>
                </PaginationLink>
            </PaginationItem>
            <PaginationItem > 
                <PaginationLink
                aria-selected={estado === 1}
                className={classnames("mb-sm-3 mb-md-0", {
                  active: estado === 1
                })}
                 onClick={e => {toggleNavs(e, "navPills", 1);paginar("1")}}
                 role="tab"
                 >
                1
                </PaginationLink>
            </PaginationItem>
            <PaginationItem>
                <PaginationLink  
                aria-selected={estado === 2}
                className={classnames("mb-sm-3 mb-md-0", {
                  active: estado === 2
                })}
                onClick={e =>{toggleNavs(e, "navPills", 2);paginar("2")} }
                role="tab"
                >
                2
                </PaginationLink>
            </PaginationItem>
            <PaginationItem>
                <PaginationLink 
                aria-selected={estado === 3}
                className={classnames("mb-sm-3 mb-md-0", {
                  active: estado === 3
                })}
                onClick={e => {toggleNavs(e, "navPills", 3);paginar("3")}}
                role="tab"
                >
                3
                </PaginationLink>
            </PaginationItem>
            <PaginationItem>
                <PaginationLink onClick={() => paginar("ADELANTE")} role="tab">
                <i className="fa fa-angle-right" />
                <span className="sr-only">Adelante</span>
                </PaginationLink>
            </PaginationItem>
            </Pagination>
        </nav>
        </>
    )
}
Paginacion.defaultProps = {
  toggleSidenav: () => {},
  sidenavOpen: false,
  theme: "dark",
};
Paginacion.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"]),
};